<script setup lang="ts">
import { ReviewSection } from '@hfc/ui-core';
import { MEMBER_TYPES } from '@hfc/common/src/types/MemberTypes';

import BaseSection from '@/application/shared/infrastructure/components/BaseSection.vue';
import PrimaryApplicantElement from '@/application/shared/infrastructure/components/Review/PrimaryApplicantElement.vue';
import ApplicantsElement from '@/application/shared/infrastructure/components/Review/ApplicantsElement.vue';
import { useDentalAndVisionApplication } from '@/shared/infrastructure/composition/useDentalAndVisionApplication';
import { AppTypeDentalOrVision } from '@/application/shared/domain/DentalAndVisionApplication';
import GuardianElement from '@/application/shared/infrastructure/components/Review/GuardianElement.vue';

const props = defineProps<{
  applicationType: AppTypeDentalOrVision;
}>();

const {
  primaryApplicant,
  notPrimaryApplicants,
} = useDentalAndVisionApplication(props.applicationType);

interface EmitInterface {
  (event: 'goToSection', value: number): void
}

const emits = defineEmits<EmitInterface>();

const iconsColor = 'text-gray-400';

const titleClass = 'text-sm font-medium text-gray-400';

defineExpose({
  sectionSubmit: () => true
});
</script>
<template>
  <BaseSection class="flex-1">
    <div class="flex flex-1 flex-col px-2">
      <div class="">
        <h2 class="text-2xl">Review</h2>
        <p>Is everything you entered correct? If yes, click "Continue" below.</p>
      </div>

      <div class="flex flex-1 flex-col mt-6 mb-6">
        <ReviewSection v-if="primaryApplicant" section-title="Primary Applicant" :section-number="1" @change-view="emits('goToSection', 2)" >
          <template #content>
            <PrimaryApplicantElement :primary-applicant="primaryApplicant" :icons-color="iconsColor" :title-class="titleClass" />
          </template>
        </ReviewSection>

        <ReviewSection v-for="applicant in notPrimaryApplicants" :key="applicant.main_index" :section-title="`${applicant.type} ${applicant.index !== undefined? applicant.index + 1 : ''}`" :section-number="1" @change-view="emits('goToSection', 4)" >
          <template #content>
            <GuardianElement v-if="applicant.type === MEMBER_TYPES.GUARDIAN" :guardian="applicant" :primary-applicant="primaryApplicant" :icons-color="iconsColor" :title-class="titleClass" />
            <ApplicantsElement v-else :applicant="applicant" :icons-color="iconsColor" :title-class="titleClass" />
          </template>
        </ReviewSection>
      </div>

    </div>
  </BaseSection>
</template>
